var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMusicIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ADB5",
    fillRule: "evenodd",
    d: "M12.461.692c0 .383-.31.693-.692.693H.692A.692.692 0 0 1 .692 0H11.77c.383 0 .692.31.692.692ZM10.615 4.385c0 .382-.31.692-.692.692H.693a.692.692 0 0 1 0-1.385h9.23c.382 0 .692.31.692.693ZM6.923 8.077c0 .382-.31.692-.692.692H.692a.692.692 0 0 1 0-1.384h5.539c.382 0 .692.31.692.692ZM6 11.77c0 .382-.31.691-.692.691H.692a.692.692 0 1 1 0-1.384h4.616c.382 0 .692.31.692.692Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ADB5",
    d: "M13.615 1.846c.383 0 .693.31.693.692a3 3 0 0 0 3 3 .692.692 0 1 1 0 1.385 4.37 4.37 0 0 1-3-1.187v4.649a3 3 0 1 1-1.385-2.529V2.54c0-.383.31-.693.692-.693Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon2);
export default __webpack_public_path__ + "static/media/music-icon-2.e85aace8a281aedf85f22117f5b4783b.svg";
export { ForwardRef as ReactComponent };